<template>
    <div class="landing-components">
        <template v-for="(item, index) in components">
            <marketing-swiper
                v-if="item.type === 'swiper'"
                :customStyle="item.props.style"
                :images="item.props.images"
                :height="item.props.height"
                :interval="item.props.interval"
                :key="index"
                :rootMark="rootMark"
                :trackSelectAction="(custom) => trackSelectAction(item, custom)"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
            />
            <marketing-image
                v-if="item.type === 'image'"
                :customStyle="item.props.style"
                :src="item.props.src"
                :href="item.props.href"
                :defaultURL="item.props.targetConfig.defaultURL"
                :key="index"
                :index="index"
                :rootMark="rootMark"
                ref="marketingImage"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="(custom) => trackSelectAction(item, custom)"
                :track-event="() => trackClickLink(item, { click_url: item.props.href })"
            />
            <marketing-text
                v-if="item.type === 'text'"
                :customStyle="item.props.style"
                :text="item.props.text"
                :key="index"
                :rootMark="rootMark"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="() => trackSelectAction(item)"
            />
            <marketing-link
                v-if="item.type === 'link'"
                :customStyle="item.props.style"
                :text="item.props.text"
                :href="item.props.href"
                :targetConfig="item.props.targetConfig"
                :track-event="(custom) => trackClickLink(item, custom)"
                :key="index"
                :index="index"
                :rootMark="rootMark"
                ref="marketingLink"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="(custom) => trackSelectAction(item, custom)"
            />
            <marketing-form
                v-if="
                    item.type === 'form' &&
                    !item.props.isQuickSubmit &&
                    !item.props.isFixedBottom
                "
                :key="index"
                :rootMark="rootMark"
                :style="item.props.style"
                :isDemo="!!watermark"
                :trackName="item.props.trackName"
                :series="series"
                :lpConfig="lpConfig"
                :formMode="pageConfig.mode"
                :presetModel="pageConfig.presetModel"
                :presetAreaCode="pageConfig.presetAreaCode"
                :campaignCode="pageConfig.campaignSourceCode"
                :welfareId="pageConfig.welfareId"
                :askingModal="pageConfig.askingModal"
                :formTitle="item.props.formTitle"
                :comment="item.props.comment"
                :fields="item.props.fields"
                :submitButtonText="item.props.submitButton.buttonText"
                :submitButtonStyle="item.props.submitButton.style"
                :privacyName="item.props.privacyName"
                :privacyLink="item.props.privacyLink"
                :privacyList="item.props.privacyList"
                :backgroundImg="item.props.backgroundImg"
                :bizType="item.props.bizType"
                :guideLink="item.props.guideLink"
                :presetChannel="pageConfig.presetChannel"
                :useGeoLocation="item.props.useGeoLocation"
                @inputFocus="handleInputFocus"
                @inputBlur="handleInputBlur"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :componentId="item.props.componentId"
                :positionRank="item.props.positionRank"
            />
            <marketing-form-quick
                v-if="
                    item.type === 'form' &&
                    (item.props.isFixedBottom || item.props.isQuickSubmit)
                "
                :key="index"
                :rootMark="rootMark"
                :style="item.props.style"
                :fixed="item.props.isFixedBottom"
                :isDemo="!!watermark"
                :trackName="item.props.trackName"
                :series="series"
                :lpConfig = "lpConfig"
                :formMode="pageConfig.mode"
                :presetModel="pageConfig.presetModel"
                :presetAreaCode="pageConfig.presetAreaCode"
                :campaignCode="pageConfig.campaignSourceCode"
                :welfareId="pageConfig.welfareId"
                :askingModal="pageConfig.askingModal"
                :formTitle="item.props.formTitle"
                :comment="item.props.comment"
                :fields="item.props.fields"
                :submitButtonText="item.props.submitButton.buttonText"
                :submitButtonStyle="item.props.submitButton.style"
                :privacyName="item.props.privacyName"
                :privacyLink="item.props.privacyLink"
                :privacyList="item.props.privacyList"
                :guideLink="item.props.guideLink"
                :presetChannel="pageConfig.presetChannel"
                :useGeoLocation="item.props.useGeoLocation"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :componentId="item.props.componentId"
                :positionRank="item.props.positionRank"
            />
            <marketing-task
                v-if="item.type === 'task'"
                ref="marketingTask"
                :key="index"
                :rootMark="rootMark"
                :customStyle="item.props.style"
                :receiveRewardsDialog="item.props.receiveRewardsDialog"
                :backgroundSetting="{
                    backgroundType: item.props.backgroundType,
                    background: item.props.background,
                }"
                :taskIconImg="item.props.taskIconImg"
                :goFinishBtnImg="item.props.goFinishBtnImg"
                :goFinishTargetUrl="item.props.goFinishTargetUrl"
                :getAwardBtnImg="item.props.getAwardBtnImg"
                :receivedBtnImg="item.props.receivedBtnImg"
                :receivedTargetUrl="item.props.receivedTargetUrl"
                :overdueBtnImg="item.props.overdueBtnImg"
                :taskTitle="item.props.taskTitle"
                :taskTitleColor="item.props.taskTitleColor"
                :taskDesc="item.props.taskDesc"
                :taskDescColor="item.props.taskDescColor"
                :awardDesc="item.props.awardDesc"
                :awardDescColor="item.props.awardDescColor"
                :taskParam="item.props.taskParam"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="(custom) => trackSelectAction(item, custom)"
            />
            <marketing-award
                v-if="item.type === 'award'"
                ref="marketingAward"
                :index="index"
                :key="index"
                :rootMark="rootMark"
                :lpConfig = "lpConfig"
                :customStyle="item.props.style"
                :fixed="item.props.isFixedBottom"
                :backgroundSetting="{
                    backgroundType: item.props.backgroundType,
                    background: item.props.background,
                }"
                :notReceivedBtnImg="item.props.notReceivedBtnImg"
                :notAvailableBtnImg="item.props.notAvailableBtnImg"
                :receivedBtnImg="item.props.receivedBtnImg"
                :awardPageLink="item.props.awardPageLink"
                :notAvailableTip="item.props.notAvailableTip"
                :channelCode="item.props.channelCode"
                :awardAliasPrimary="item.props.awardAliasPrimary"
                :awardAliasSecondary="item.props.awardAliasSecondary"
                :crowdConditionId="item.props.crowdConditionId"
                :distanceDescColor="item.props.distanceDescColor"
                :refreshBtnColor="item.props.refreshBtnColor"
                :distanceValid="item.props.distanceValid"
                :locationType="item.props.locationType"
                :coordinates="item.props.coordinates"
                :coordinatesName="item.props.coordinatesName"
                :disableLocate="item.props.disableLocate"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="(custom) => trackSelectAction(item, custom)"
                :componentId="item.props.componentId"
                :positionRank="item.props.positionRank"
                :formMode="pageConfig.mode"
                :trackName="item.props.trackName"
            />
            <marketing-leads-award
                v-if="item.type === 'leads_award'"
                ref="marketingLeadsAward"
                :index="index"
                :key="index"
                :rootMark="rootMark"
                :lpConfig = "lpConfig"
                :customStyle="item.props.style"
                :fixed="item.props.isFixedBottom"
                :backgroundSetting="{
                    backgroundType: item.props.backgroundType,
                    background: item.props.background,
                }"
                :buttonImage="item.props.buttonImage"
                :textStyle="item.props.textStyle"
                :textColor="item.props.textStyle.textColor"
                :placeholderColor="item.props.textStyle.placeholderColor"
                :awardPageLink="item.props.awardPageLink"
                :distanceValid="item.props.locationConfig.distanceValid"
                :locationType="item.props.locationConfig.locationType"
                :coordinates="item.props.locationConfig.coordinates"
                :coordinatesName="item.props.locationConfig.coordinatesName"
                :locationSwitch="item.props.locationSwitch"
                :fields="item.props.fields"
                @inputFocus="handleInputFocus"
                @inputBlur="handleInputBlur"

                :trackName="item.props.trackName"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :isDemo="!!watermark"
                :formMode="pageConfig.mode"
                :componentId="item.props.componentId"
                :positionRank="item.props.positionRank"
                :invitationText="item.props.invitationText"
            />
            <marketing-video
                v-if="item.type === 'video'"
                :key="index"
                :rootMark="rootMark"
                :customStyle="item.props.style"
                :src="item.props.src"
                :poster="item.props.poster"
                :autoplay="item.props.autoplay"
                @trackExposeAction="() => trackExposeAction(item)"
                :trackSelectAction="() => trackSelectAction(item)"
            />
            <marketing-corp-authentication
                v-if="item.type === 'corp_authentication'"
                :key="index"
                :rootMark="rootMark"
                :customStyle="item.props.style"
                :campaignCode="pageConfig.campaignSourceCode"
                :emailAuthConfig="item.props.emailAuthConfig"
                :enterpriseCode="item.props.enterpriseCode"
                :passPage="item.props.nextPages.pass"
                :inactivePage="item.props.nextPages.inactive"
                @inputFocus="handleInputFocus"
                @inputBlur="handleInputBlur"

                :trackName="item.props.trackName"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="(custom) => trackSelectAction(item, custom)"
                :trackCommonAction="(step, custom) => trackCommonAction(item, step, custom)"
                :componentId="item.props.componentId"
                :positionRank="item.props.positionRank"
            />
            <marketing-fellow
                v-if="item.type === 'fellow'"
                :custom-style="item.props.style"
                :user-id="userId"
                :fellowInfo="fellowInfo"
                :track-event="trackClickCall"
                :key="index"
                :rootMark="rootMark"
                @trackExposeAction="(custom) => trackExposeAction(item, custom)"
                :trackSelectAction="() => trackSelectAction(item)"
            />
        </template>
    </div>
</template>

<script>
import MarketingSwiper from './swiper';
import MarketingForm from './form';
import MarketingFormQuick from './quick';
import MarketingImage from './image';
import MarketingText from './text';
import MarketingLink from './link';
import MarketingTask from './task';
import MarketingAward from './award/award';
import MarketingLeadsAward from './leads-award/award';
import MarketingVideo from './video';
import MarketingCorpAuthentication from './corp-authentication';
import MarketingFellow from './fellow';

export default {
    components: {
        MarketingSwiper,
        MarketingForm,
        MarketingFormQuick,
        MarketingImage,
        MarketingText,
        MarketingLink,
        MarketingTask,
        MarketingAward,
        MarketingLeadsAward,
        MarketingVideo,
        MarketingCorpAuthentication,
        MarketingFellow
    },
    props: {
        components: {
            type: Array,
            default: () => []
        },
        rootMark: {
            type: String,
            default: ''
        },
        trackExposeAction: Function,
        trackSelectAction: Function,
        trackClickLink: Function,
        trackCommonAction: Function,
        trackClickCall: Function,
        // landing
        watermark: {
            type: String
        },
        series: {
            type: Array,
            default: () => []
        },
        pageConfig: {
            type: Object,
            default: () => ({})
        },
        userId: {
            type: String,
            default: ''
        },
        fellowInfo: Object,
        lpConfig: {
            type: Object,
            default: () => ({
                lpId: null,
                lpToken: null
            })
        }
    },
    methods: {
        updateTaskComps() {
            const { marketingTask = [] } = this.$refs || {};

            marketingTask.forEach(
                component => component && component.init && component.init()
            );
        },
        handleInputFocus(rootMark, el) {
            this.$emit('inputFocus', rootMark, el);
        },
        handleInputBlur(rootMark) {
            this.$emit('inputBlur', rootMark);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/marketing/components/components-template.vue